import { useMutation, useQuery } from '@apollo/react-hooks';
import { useNavigator } from '../components/Navigator';
import useNotifier from '../components/Messages/hooks';
import { extractDataError } from '../utils/errors';

const useDataList = ({ schema, router, variables }) => {
  const navigate = useNavigator();
  const pushMessage = useNotifier();
  const [manyQuery, manyKey] = schema.many();
  const [deleteMutation, deleteKey] = schema.delete();
  const [deleteStatementMutation, deleteKeyStatement] = schema.delete();
  const [deleteProtocolMutation, deleteKeyProtocol] = schema.delete();
  const { loading, data, refetch } = useQuery(manyQuery, {
    variables,
    fetchPolicy: 'no-cache',
  });

  const [doDelete, { loading: deleteLoading }] = useMutation(deleteMutation, {
    onCompleted: (d) => {
      if (d[deleteKey].ok) {
        pushMessage({ text: 'Успішно видалено' });
      } else {
        const dataError = extractDataError(d[deleteKey].errors);
        pushMessage({ text: dataError });
      }
      refetch({ variables });
    },
  });
  const [doDeleteStatement] = useMutation(deleteStatementMutation, {
    onCompleted: (d) => {
      if (d[deleteKeyStatement].ok) {
        pushMessage({ text: 'Успішно видалено' });
      }
      refetch({ variables });
    },
  });
  const [doDeleteProtocol] = useMutation(deleteProtocolMutation, {
    onCompleted: (d) => {
      if (d[deleteKeyProtocol].ok) {
        pushMessage({ text: 'Успішно видалено' });
      }
      refetch({ variables });
    },
  });

  const onEdit = (e, data) => {
    navigate(router.edit(data.id));
  };

  const onAdd = () => {
    navigate(router.create());
  };

  const onDelete = (data) => {
    doDelete({ variables: { id: data.id } });
  };

  const onDeleteStatement = (data) => {
    doDeleteStatement({
      variables: { id: data.trainerId, certificationId: data.certificationsId },
    });
  };

  const onDeleteProtocol = (data) => {
    doDeleteProtocol({
      variables: { rank: data.rank, certificationId: data.certificationsId },
    });
  };

  return {
    data: data && data[manyKey],
    loading: loading || deleteLoading,
    onEdit,
    onAdd,
    onDelete,
    onDeleteStatement,
    onDeleteProtocol,
    refetch,
  };
};

export default useDataList;
